import flex_sandbox from "./flex_sandbox/flex_sandbox";
import magic_flex from "./magic_flex/magic_flex";
import knicks from "./knicks/knicks";
import rangers from "./rangers/rangers";
import pistons_flex from "./pistons_flex/pistons_flex";
import baa_baltimore from "./baa_baltimore/baa_baltimore";
import baa_indy from "./baa_indianapolis/baa_indianapolis";
import warriors from "./warriors/warriors";
import devils_flex from "./devils_flex/devils_flex";
import pistons_holiday from "./pistons_holiday/pistons_holiday";
import msg_suite from "./msg_suite/msg_suite";
import predators from "./predators/predators";
import dbacks_gift from "./dbacks_gift/dbacks_gift";
import tdc_flex_sandbox from "./tdc_flex_sandbox/tdc_flex_sandbox";
import tdc_flex_certification from "./tdc_flex_certification/tdc_flex_certification";
import warriors_gift from "./warriors_gift/warriors_gift";
import pistons_bundle from "./pistons_bundle/pistons_bundle";
import aviators_flex from "./aviators_flex/aviators_flex";
import dbacks_suites from "./dbacks_suites/dbacks_suites";
import predators_flex from "./predators_flex/predators_flex";
import dbacks_flex from "./dbacks_flex/dbacks_flex";
import mwc_bball from "./mwc_bball/mwc_bball";
import united_flex from "./united_flex/united_flex";
import sandbox_perks from "./sandbox_perks/sandbox_perks";
import dbacks_suite from "./dbacks_suite/dbacks_suite";
import flex_sandbox_knicks from "./flex_sandbox_knicks/flex_sandbox_knicks";
import flex_sandbox_warriors from "./flex_sandbox_warriors/flex_sandbox_warriors";
import flex_sandbox_predators from "./flex_sandbox_predators/flex_sandbox_predators";
import flex_sandbox_athletics from "./flex_sandbox_athletics/flex_sandbox_athletics";
import timberrattlers_flex from "./timberrattlers_flex/timberrattlers_flex";
import flex_sandbox_mwc_bball from "./flex_sandbox_mwc_bball/flex_sandbox_mwc_bball";
import { TeamConfig } from "./types";
import { CLIENT_ID_MAPPING } from "./CLIENT_ID_MAPPING";
import { errorMessages } from "../errorMessages";
import flex_sandbox_gift from "./flex_sandbox_gift/flex_sandbox_gift";
import flex_sandbox_united_flex from "./flex_sandbox_united_flex/flex_sandbox_united_flex";
import timberrattlersbark_flex from "./timberrattlersbark_flex/timberrattlersbark_flex";
import athletics_flex from "./athletics_flex/athletics_flex";
import jaguars_flex from "./jaguars_flex/jaguars_flex";
import flex_sandbox_suite from "./flex_sandbox_suite/flex_sandbox_suite";
import dbacks_hondorodeo from "./dbacks_hondorodeo/dbacks_hondorodeo";
import winnipegjets_flex from "./winnipegjets_flex/winnipegjets_flex";
import devils_pickem from "./devils_pickem/devils_pickem";
import dbacks_suites_clone from "./dbacks_suites_clone/dbacks_suites_clone";
import stlouisblues_flex from "./stlouisblues_flex/stlouisblues_flex";
import texasrangers_suites from "./texasrangers_suites/texasrangers_suites";
import predators_pickem from "./predators_pickem/predators_pickem";
import pistons_accountrep from "./pistons_accountrep/pistons_accountrep";
import devils_miniplan from "./devils_miniplan/devils_miniplan";
import fcs from "./fcs/fcs";
import baa_dallas from "./baa_dallas/baa_dallas";
import baa_houston from "./baa_houston/baa_houston";
import baa_calgary from "./baa_calgary/baa_calgary";
import baa_edmonton from "./baa_edmonton/baa_edmonton";
import baa_vancouver from "./baa_vancouver/baa_vancouver";
import flex_sandbox_suites from "./flex_sandbox_suites/flex_sandbox_suites";
import brooklynnets_flex from "./brooklynnets_flex/brooklynnets_flex";
import devils_holiday from "./devils_holiday/devils_holiday";
import predators_holiday from "./predators_holiday/predators_holiday";
import okccomets_flex from "./okccomets_flex/okccomets_flex";
import sanjosegiants_flex from "./sanjosegiants_flex/sanjosegiants_flex";
import altoonacurve_flex from "./altoonacurve_flex/altoonacurve_flex";
import inlandempire66ers_flex from "./inlandempire66ers_flex/inlandempire66ers_flex";
import stlouisblues_giftcards from "./stlouisblues_giftcards/stlouisblues_giftcards";
import swbrailriders_flex from "./swbrailriders_flex/swbrailriders_flex";
import memphisredbirds_flex from "./memphisredbirds_flex/memphisredbirds_flex";
import predators_packs from "./predators_packs/predators_packs";
import wichitawindsurge_flex from "./wichitawindsurge_flex/wichitawindsurge_flex";
import albuquerqueisotopes_flex from "./albuquerqueisotopes_flex/albuquerqueisotopes_flex";
import iowacubs_flex from "./iowacubs_flex/iowacubs_flex";
import springfieldcardinals_flex from "./springfieldcardinals_flex/springfieldcardinals_flex";
import hickorycrawdads_flex from "./hickorycrawdads_flex/hickorycrawdads_flex";
import augustagreenjackets_flex from "./augustagreenjackets_flex/augustagreenjackets_flex";
import fresnogrizzlies_flex from "./fresnogrizzlies_flex/fresnogrizzlies_flex";
import midlandrockhounds_flex from "./midlandrockhounds_flex/midlandrockhounds_flex";
import tulsadrillers_flex from "./tulsadrillers_flex/tulsadrillers_flex";
import vancouvercanadians_flex from "./vancouvercanadians_flex/vancouvercanadians_flex";
import saintpaulsaints_flex from "./saintpaulsaints_flex/saintpaulsaints_flex";
import portlandseadogs_flex from "./portlandseadogs_flex/portlandseadogs_flex";
import newhampshirefishercats_flex from "./newhampshirefishercats_flex/newhampshirefishercats_flex";
import hubcityspartanburgers_flex from "./hubcityspartanburgers_flex/hubcityspartanburgers_flex";
import worcesterredsox_flex from "./worcesterredsox_flex/worcesterredsox_flex";
import louisvillebats_flex from "./louisvillebats_flex/louisvillebats_flex";
import louisvillebats_flexpack from "./louisvillebats_flexpack/louisvillebats_flexpack";
import lansinglugnuts_flex from "./lansinglugnuts_flex/lansinglugnuts_flex";
import hvrenegades_flex from "./hvrenegades_flex/hvrenegades_flex";
import norfolktides_flex from "./norfolktides_flex/norfolktides_flex";
import sacramentokings_flex from "./sacramentokings_flex/sacramentokings_flex";
import winnipegjets_bizpassport from "./winnipegjets_bizpassport/winnipegjets_bizpassport";
import salemredsox_flex from "./salemredsox_flex/salemredsox_flex";
import winstonsalemdash_flex from "./winstonsalemdash_flex/winstonsalemdash_flex";
import aviators_suites from "./aviators_suites/aviators_suites";
import devils_minipack from "./devils_minipack/devils_minipack";
import sanantoniospurs_flex from "./sanantoniospurs_flex/sanantoniospurs_flex";
import stlouiscardinals_suites from "./stlouiscardinals_suites/stlouiscardinals_suites";
import winnipegjets_flex_sandbox from "./winnipegjets_flex_sandbox/winnipegjets_flex_sandbox";
import gwinnettstripers_flex from "./gwinnettstripers_flex/gwinnettstripers_flex";
import houstonastros_suites from "./houstonastros_suites/houstonastros_suites";
import binghamtonrumbleponies_flex from "./binghamtonrumbleponies_flex/binghamtonrumbleponies_flex";
import aviators_flexpack from "./aviators_flexpack/aviators_flexpack";
import albuquerqueisotopes_flexpack from "./albuquerqueisotopes_flexpack/albuquerqueisotopes_flexpack";
import renoaces_suites from "./renoaces_suites/renoaces_suites";
import newyorkyankees_suites from "./newyorkyankees_suites/newyorkyankees_suites";
import newyorkyankees_suites_iomedia from "./newyorkyankees_suites_iomedia/newyorkyankees_suites_iomedia";
import livenation_ruoffmusiccenter from "./livenation_ruoffmusiccenter/livenation_ruoffmusiccenter";
import livenation_midfloridasuites from "./livenation_midfloridasuites/livenation_midfloridasuites";
import flex_sandbox_groups from "./flex_sandbox_groups/flex_sandbox_groups";
import memphisredbirds_flexpack from "./memphisredbirds_flexpack/memphisredbirds_flexpack";
import sanantoniofc_suites from "./sanantoniofc_suites/sanantoniofc_suites";
import tricitydustdevils_flex from "./tricitydustdevils_flex/tricitydustdevils_flex";
import dbacks_groups from "./dbacks_groups/dbacks_groups";
import orlandomagic_10pack from "./orlandomagic_10pack/orlandomagic_10pack";
import tampabayrays_suites from "./tampabayrays_suites/tampabayrays_suites";
import tampabayrays_postseasonsuites from "./tampabayrays_postseasonsuites/tampabayrays_postseasonsuites";
import brooklyncyclones_flex from "./brooklyncyclones_flex/brooklyncyclones_flex";
import texasrangers_sandbox from "./texasrangers_sandbox/texasrangers_sandbox";
import stlouiscardinals_sandbox from "./stlouiscardinals_sandbox/stlouiscardinals_sandbox";
import sacramentokings_flex_sandbox from "./sacramentokings_flex_sandbox/sacramentokings_flex_sandbox";
import rcquakes_flex from "./rcquakes_flex/rcquakes_flex";
import newyorkyankees_flex from "./newyorkyankees_flex/newyorkyankees_flex";
import atlantahawks_suites from "./atlantahawks_suites/atlantahawks_suites";
import livenation_hollywoodcasinostl_suites from "./livenation_hollywoodcasinostl_suites/livenation_hollywoodcasinostl_suites";
import livenation_midflorida_suites from "./livenation_midflorida_suites/livenation_midflorida_suites";
import livenation_pncmusicpavilion_suites from "./livenation_pncmusicpavilion_suites/livenation_pncmusicpavilion_suites";
import livenation_xfinitycenter_suites from "./livenation_xfinitycenter_suites/livenation_xfinitycenter_suites";
import livenation_darienlake_suites from "./livenation_darienlake_suites/livenation_darienlake_suites";
import livenation_talkingstickresort_suites from "./livenation_talkingstickresort_suites/livenation_talkingstickresort_suites";
import livenation_skylacreditunion_suites from "./livenation_skylacreditunion_suites/livenation_skylacreditunion_suites";
import livenation_bankofnewhampshire_suites from "./livenation_bankofnewhampshire_suites/livenation_bankofnewhampshire_suites";
import livenation_pncbankartscenter_suites from "./livenation_pncbankartscenter_suites/livenation_pncbankartscenter_suites";
import livenation_coastalcreditunion_suites from "./livenation_coastalcreditunion_suites/livenation_coastalcreditunion_suites";
import bankofnewhampshire_premium from "./bankofnewhampshire_premium/bankofnewhampshire_premium";
import coastalcreditunion_premium from "./coastalcreditunion_premium/coastalcreditunion_premium";
import darienlake_premium from "./darienlake_premium/darienlake_premium";
import hollywoodcasinostl_premium from "./hollywoodcasinostl_premium/hollywoodcasinostl_premium";
import midflorida_premium from "./midflorida_premium/midflorida_premium";
import pncbankartscenter_premium from "./pncbankartscenter_premium/pncbankartscenter_premium";
import pncmusicpavilion_premium from "./pncmusicpavilion_premium/pncmusicpavilion_premium";
import skylacreditunion_premium from "./skylacreditunion_premium/skylacreditunion_premium";
import talkingstickresort_premium from "./talkingstickresort_premium/talkingstickresort_premium";
import xfinitycenter_premium from "./xfinitycenter_premium/xfinitycenter_premium";
import cascadesamphitheater_premium from "./cascadesamphitheater_premium/cascadesamphitheater_premium";
import veteransunited_premium from "./veteransunited_premium/veteransunited_premium";
import whiteriveramphitheatre_premium from "./whiteriveramphitheatre_premium/whiteriveramphitheatre_premium";
import freedommortgagepavilion_premium from "./freedommortgagepavilion_premium/freedommortgagepavilion_premium";
import dosequispavilion_premium from "./dosequispavilion_premium/dosequispavilion_premium";
import creditunion1_premium from "./creditunion1_premium/creditunion1_premium";
import jiffylubelive_premium from "./jiffylubelive_premium/jiffylubelive_premium";
import pavilionatstarlake_premium from "./pavilionatstarlake_premium/pavilionatstarlake_premium";
import northislandcreditunion_premium from "./northislandcreditunion_premium/northislandcreditunion_premium";
import newyorkyankees_bananas_suites from "./newyorkyankees_bananas_suites/newyorkyankees_bananas_suites";
import winnipegjets_passport from "./winnipegjets_passport/winnipegjets_passport";
import huntingtonbank_premium from "./huntingtonbank_premium/huntingtonbank_premium";
import jaguars_pack from "./jaguars_pack/jaguars_pack";
import sackings_flexbank from "./sackings_flexbank/sackings_flexbank";
import msg from "./msg/msg";
import milwaukeebucks_flex from "./milwaukeebucks_flex/milwaukeebucks_flex";
import sandbox_accountrep from "./sandbox_accountrep/sandbox_accountrep";
import calgary_flexbank from "./calgary_flexbank/calgary_flexbank";
import philadelphiaflyers_flex from "./philadelphiaflyers_flex/philadelphiaflyers_flex";
import ascendamphitheater_premium from "./ascendamphitheater_premium/ascendamphitheater_premium";
import shorelineamphitheatre_premium from "./shorelineamphitheatre_premium/shorelineamphitheatre_premium";
import utahfirst_premium from "./utahfirst_premium/utahfirst_premium";
import newyorkyankees_suites_postseason from "./newyorkyankees_suites_postseason/newyorkyankees_suites_postseason";
import columbusbluejackets_suites from "./columbusbluejackets_suites/columbusbluejackets_suites";
import atlantadream_flex from "./atlantadream_flex/atlantadream_flex";
import atlantahawks_flex from "./atlantahawks_flex/atlantahawks_flex";
import pittsburghpenguins_flex from "./pittsburghpenguins_flex/pittsburghpenguins_flex";
import fillmoresilverspring_premium from "./fillmoresilverspring_premium/fillmoresilverspring_premium";
import oakdaletheatre_premium from "./oakdaletheatre_premium/oakdaletheatre_premium";
import brooklynnets_packs from "./brooklynnets_packs/brooklynnets_packs";
import winnipegjets_gamepack from "./winnipegjets_gamepack/winnipegjets_gamepack";
import placedesarts_giftcard from "./placedesarts_giftcard/placedesarts_giftcard";
import grandtheatre_giftcard from "./grandtheatre_giftcard/grandtheatre_giftcard";
import cincinnatireds_suites from "./cincinnatireds_suites/cincinnatireds_suites";
import phoenixsuns_flex from "./phoenixsuns_flex/phoenixsuns_flex";
import newyorkyankees_bananas_flex from "./newyorkyankees_bananas_flex/newyorkyankees_bananas_flex";
import dbacks_miniplans from "./dbacks_miniplans/dbacks_miniplans";
import coloradorockies_flex from "./coloradorockies_flex/coloradorockies_flex";
import sacramentorivercats_flex from "./sacramentorivercats_flex/sacramentorivercats_flex";
import torontobluejays_flex from "./torontobluejays_flex/torontobluejays_flex";
import sanantoniospurs_holiday from "./sanantoniospurs_holiday/sanantoniospurs_holiday";
import mountainwest_flex from "./mountainwest_flex/mountainwest_flex";
import phoenixsuns_flexbundle from "./phoenixsuns_flexbundle/phoenixsuns_flexbundle";
import coloradorockies_groups from "./coloradorockies_groups/coloradorockies_groups";
import torontobluejays_groups from "./torontobluejays_groups/torontobluejays_groups";
import seattlesounders_groups from "./seattlesounders_groups/seattlesounders_groups";
import newyorkrangers_groups from "./newyorkrangers_groups/newyorkrangers_groups";
import seattlereign_groups from "./seattlereign_groups/seattlereign_groups";
import newyorkknicks_groups from "./newyorkknicks_groups/newyorkknicks_groups";
import detroitredwings_groups from "./detroitredwings_groups/detroitredwings_groups";
import northwestarkansasnaturals_flex from "./northwestarkansasnaturals_flex/northwestarkansasnaturals_flex";
import nationwidearena_suites from "./nationwidearena_suites/nationwidearena_suites";
import pennstate_suites from "./pennstate_suites/pennstate_suites";
import orlandocitysc_flex from "./orlandocitysc_flex/orlandocitysc_flex";
import orlandopride_flex from "./orlandopride_flex/orlandopride_flex";
import mlb_flex from "./mlb_flex/mlb_flex";
import northwestarkansasnaturals_gamepacks from "./northwestarkansasnaturals_gamepacks/northwestarkansasnaturals_gamepacks";
import dbacks_groupspaces from "./dbacks_groupspaces/dbacks_groupspaces";
import prudentialcenter_suites from "./prudentialcenter_suites/prudentialcenter_suites";
import phoenixmercury_flex from "./phoenixmercury_flex/phoenixmercury_flex";
import aviators_groups from "./aviators_groups/aviators_groups";
import saltlakebees_suites from "./saltlakebees_suites/saltlakebees_suites";
import philadelphia76ers_suites from "./philadelphia76ers_suites/philadelphia76ers_suites";
import dbacks_specialeventsuites from "./dbacks_specialeventsuites/dbacks_specialeventsuites";
import gorge_premium from "./gorge_premium/gorge_premium";
import orlandomagic_20pack from "./orlandomagic_20pack/orlandomagic_20pack";
import toyotaamphitheatre_premium from "./toyotaamphitheatre_premium/toyotaamphitheatre_premium";
import toyotapavilion_premium from "./toyotapavilion_premium/toyotapavilion_premium";
import lakewoodamphitheatre_premium from "./lakewoodamphitheatre_premium/lakewoodamphitheatre_premium";
import montagemountain_premium from "./montagemountain_premium/montagemountain_premium";
import cincinnatireds_bananas_suites from "./cincinnatireds_bananas_suites/cincinnatireds_bananas_suites";
import orlandomagic_fullseason from "./orlandomagic_fullseason/orlandomagic_fullseason";
import iowastate_tents from "./iowastate_tents/iowastate_tents";
import dbacks_miniplanscomp from "./dbacks_miniplanscomp/dbacks_miniplanscomp";
import texasrangers_postseasonsuites from "./texasrangers_postseasonsuites/texasrangers_postseasonsuites";

const baseConfigs: TeamConfig[] = [
  flex_sandbox,
  magic_flex,
  knicks,
  rangers,
  pistons_flex,
  baa_baltimore,
  baa_indy,
  warriors,
  devils_flex,
  pistons_holiday,
  msg_suite,
  predators,
  dbacks_gift,
  tdc_flex_sandbox,
  pistons_bundle,
  aviators_flex,
  dbacks_suites,
  predators_flex,
  dbacks_flex,
  mwc_bball,
  united_flex,
  tdc_flex_certification,
  warriors_gift,
  sandbox_perks,
  dbacks_suite,
  flex_sandbox_knicks,
  flex_sandbox_warriors,
  flex_sandbox_predators,
  flex_sandbox_athletics,
  timberrattlers_flex,
  flex_sandbox_mwc_bball,
  flex_sandbox_gift,
  flex_sandbox_united_flex,
  timberrattlersbark_flex,
  athletics_flex,
  jaguars_flex,
  flex_sandbox_suite,
  dbacks_hondorodeo,
  winnipegjets_flex,
  devils_pickem,
  dbacks_suites_clone,
  stlouisblues_flex,
  texasrangers_suites,
  texasrangers_postseasonsuites,
  predators_pickem,
  pistons_accountrep,
  devils_miniplan,
  fcs,
  baa_dallas,
  baa_houston,
  baa_calgary,
  baa_edmonton,
  baa_vancouver,
  flex_sandbox_suites,
  brooklynnets_flex,
  devils_holiday,
  predators_holiday,
  okccomets_flex,
  sanjosegiants_flex,
  inlandempire66ers_flex,
  altoonacurve_flex,
  stlouisblues_giftcards,
  swbrailriders_flex,
  memphisredbirds_flex,
  predators_packs,
  wichitawindsurge_flex,
  albuquerqueisotopes_flex,
  iowacubs_flex,
  springfieldcardinals_flex,
  hickorycrawdads_flex,
  augustagreenjackets_flex,
  fresnogrizzlies_flex,
  midlandrockhounds_flex,
  tulsadrillers_flex,
  vancouvercanadians_flex,
  saintpaulsaints_flex,
  portlandseadogs_flex,
  newhampshirefishercats_flex,
  hubcityspartanburgers_flex,
  worcesterredsox_flex,
  louisvillebats_flex,
  louisvillebats_flexpack,
  lansinglugnuts_flex,
  hvrenegades_flex,
  norfolktides_flex,
  sacramentokings_flex,
  winnipegjets_bizpassport,
  salemredsox_flex,
  winstonsalemdash_flex,
  aviators_suites,
  devils_minipack,
  sanantoniospurs_flex,
  stlouiscardinals_suites,
  winnipegjets_flex_sandbox,
  gwinnettstripers_flex,
  houstonastros_suites,
  binghamtonrumbleponies_flex,
  aviators_flexpack,
  albuquerqueisotopes_flexpack,
  renoaces_suites,
  newyorkyankees_suites,
  newyorkyankees_suites_iomedia,
  livenation_ruoffmusiccenter,
  livenation_midfloridasuites,
  flex_sandbox_groups,
  memphisredbirds_flexpack,
  sanantoniofc_suites,
  tricitydustdevils_flex,
  dbacks_groups,
  orlandomagic_10pack,
  tampabayrays_suites,
  tampabayrays_postseasonsuites,
  brooklyncyclones_flex,
  texasrangers_sandbox,
  stlouiscardinals_sandbox,
  sacramentokings_flex_sandbox,
  rcquakes_flex,
  newyorkyankees_flex,
  atlantahawks_suites,
  livenation_hollywoodcasinostl_suites,
  livenation_midflorida_suites,
  livenation_pncmusicpavilion_suites,
  livenation_xfinitycenter_suites,
  livenation_darienlake_suites,
  livenation_talkingstickresort_suites,
  livenation_skylacreditunion_suites,
  livenation_bankofnewhampshire_suites,
  livenation_pncbankartscenter_suites,
  livenation_coastalcreditunion_suites,
  bankofnewhampshire_premium,
  coastalcreditunion_premium,
  darienlake_premium,
  hollywoodcasinostl_premium,
  midflorida_premium,
  pncbankartscenter_premium,
  pncmusicpavilion_premium,
  skylacreditunion_premium,
  talkingstickresort_premium,
  xfinitycenter_premium,
  cascadesamphitheater_premium,
  veteransunited_premium,
  whiteriveramphitheatre_premium,
  freedommortgagepavilion_premium,
  dosequispavilion_premium,
  creditunion1_premium,
  jiffylubelive_premium,
  pavilionatstarlake_premium,
  northislandcreditunion_premium,
  newyorkyankees_bananas_suites,
  winnipegjets_passport,
  huntingtonbank_premium,
  jaguars_pack,
  sackings_flexbank,
  msg,
  milwaukeebucks_flex,
  sandbox_accountrep,
  calgary_flexbank,
  philadelphiaflyers_flex,
  ascendamphitheater_premium,
  shorelineamphitheatre_premium,
  utahfirst_premium,
  newyorkyankees_suites_postseason,
  columbusbluejackets_suites,
  atlantadream_flex,
  atlantahawks_flex,
  pittsburghpenguins_flex,
  fillmoresilverspring_premium,
  oakdaletheatre_premium,
  brooklynnets_packs,
  winnipegjets_gamepack,
  placedesarts_giftcard,
  grandtheatre_giftcard,
  cincinnatireds_suites,
  phoenixsuns_flex,
  newyorkyankees_bananas_flex,
  dbacks_miniplans,
  coloradorockies_flex,
  sacramentorivercats_flex,
  torontobluejays_flex,
  sanantoniospurs_holiday,
  mountainwest_flex,
  phoenixsuns_flexbundle,
  coloradorockies_groups,
  torontobluejays_groups,
  seattlesounders_groups,
  newyorkrangers_groups,
  seattlereign_groups,
  newyorkknicks_groups,
  detroitredwings_groups,
  northwestarkansasnaturals_flex,
  nationwidearena_suites,
  pennstate_suites,
  orlandocitysc_flex,
  orlandopride_flex,
  mlb_flex,
  northwestarkansasnaturals_gamepacks,
  dbacks_groupspaces,
  prudentialcenter_suites,
  phoenixmercury_flex,
  aviators_groups,
  saltlakebees_suites,
  philadelphia76ers_suites,
  dbacks_specialeventsuites,
  gorge_premium,
  orlandomagic_20pack,
  toyotaamphitheatre_premium,
  toyotapavilion_premium,
  lakewoodamphitheatre_premium,
  montagemountain_premium,
  cincinnatireds_bananas_suites,
  orlandomagic_fullseason,
  iowastate_tents,
  dbacks_miniplanscomp,
];

function withClientIdMapping(teamConfigs: TeamConfig[]) {
  return teamConfigs.map((cfg) => {
    cfg.clientId = CLIENT_ID_MAPPING[cfg.teamSchema as keyof typeof CLIENT_ID_MAPPING]; // prettier-ignore
    if (!cfg.clientId) throw new Error(errorMessages.noClientIdFound);
    return cfg;
  });
}

export const teamConfigs = withClientIdMapping(baseConfigs);
